export const isMobile = () => { 
  return window.innerWidth < 600;
}
